/* eslint-disable */
export default {
  copyToClipboard: 'Copier dans le Presse-papiers',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
